export default "__VITE_ASSET__d7715a55__"